
import state from './moduleContactsManagementState'
import mutations from './moduleContactsManagementMutations'
import actions from './moduleContactsManagementActions'
import getters from './moduleContactsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

